import Vue from 'vue'
import Router from 'vue-router'
import { Routers } from './routers'
import util from '../libs/utils'

Vue.use(Router)

let route = new Router({
  routes: Routers
})
route.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  if (to.matched.some(record => record.meta.requiresAuth) && !to.query.token && to.path !== '/forgetPwd') {
    let token = util.getAuthCode()
    // 判断是否有token
    if (!token) {
      // 判断网址是否是 https://zydemo.genekang.com 是的话跳转到中源协和首页/exhibition  在/exhibition请求接口获取token
      // if(window.location.origin === 'https://zydemo.genekang.com'){
      //   next({
      //     name: 'exhibition'
      //   })
      // }else{
      // 如果不是就去登陆页面
        next({
          name: 'login',
          query: { redirect: to.fullPath }
        })
      // }
      // 有token判断输入的是否是中源协和网址是的话到 /exhibition 首页
    }
    else if(window.location.href === 'https://zydemo.genekang.com/#/'){
      // console.log(from);
      // if (from.path == '/') {
        next({
          name: 'exhibition'
        })
      // }else{
      //   next()
      // }
    }
    else{
      next()
    }
  } else {
    next()
  }
})

export default route



// WEBPACK FOOTER //
// ./src/router/index.js